export default __webpack_public_path__ + "static/media/will.1df040f9.png";